import { Protocol } from '../../types/sharedTypeImpl.ts';
import { OperatorSelect } from '../operatorSelect.tsx';


interface Props {
    protocol: Protocol;
    mode: 'edit' | 'view' | 'review';
    reviewer: string;
    setReviewer: (reviewer: string) => void;
    reviewComment: string;
    setReviewComment: (comment: string) => void;
}

export function ProtocolFormReview({
    protocol,
    mode,
    reviewer,
    setReviewer,
    reviewComment,
    setReviewComment,
}: Props) {

    const latestReview = protocol.reviews?.at(-1);
    const showReviewer = mode === 'review' || latestReview;
    const showReviewComment = mode === 'review' || protocol.status === 'rejected';

    return <>
        {(showReviewer || showReviewComment) &&
            <table className='record-form--table' style={{ marginTop: '20px' }}>
                <tbody>
                    {showReviewer && <tr>
                        <td>Reviewer</td>
                        <td>
                            <OperatorSelect
                                operatorInitials={mode === 'review' ? reviewer : latestReview?.operator ?? ''}
                                readOnly={mode !== 'review'}
                                onChange={(initials) => setReviewer(initials)}
                                required
                            />
                        </td>
                    </tr>}
                    {showReviewComment && <tr>
                        <td>Comment</td>
                        <td>
                            <textarea
                                name='reviewComment'
                                value={mode === 'review' ? reviewComment : latestReview?.comment ?? ''}
                                rows={3}
                                readOnly={mode !== 'review'}
                                onChange={(e) => setReviewComment(e.target.value)}
                            />
                        </td>
                    </tr>}
                </tbody>
            </table>
        }
    </>;
}